<script lang="ts">
  import { geheZu, router } from './router.svelte.ts';

  let offen = $state(false);

  /** Zu einem Anker springen — von jeder Seite aus, nicht nur der Startseite. */
  function zuAbschnitt(ereignis: MouseEvent, id: string): void {
    ereignis.preventDefault();
    offen = false;
    if (router.pfad !== '/') {
      geheZu('/');
      // Erst rendern lassen, dann scrollen – der Abschnitt existiert vorher nicht im DOM.
      requestAnimationFrame(() => requestAnimationFrame(() => springe(id)));
    } else {
      springe(id);
    }
  }

  function springe(id: string): void {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function zurStartseite(ereignis: MouseEvent): void {
    ereignis.preventDefault();
    offen = false;
    geheZu('/');
  }

  /** Router-Seite (kein Anker, keine statische Seite) ohne Neuladen öffnen. */
  function navigiere(ereignis: MouseEvent, pfad: string): void {
    ereignis.preventDefault();
    offen = false;
    geheZu(pfad);
  }
</script>

<header class="kopfleiste">
  <div class="innen">
    <a href="/" class="marke" onclick={zurStartseite}>
      <img src="/logo-hell.png" alt="" width="138" height="32" />
      <span class="sr-only">IT-Service Karsten Fischer</span>
    </a>

    <nav class="kopfnav desktop" aria-label="Hauptnavigation">
      <a class="link" href="/#leistungen" onclick={(e) => zuAbschnitt(e, 'leistungen')}>
        Technik-Support
      </a>
      <a class="link" href="/#servicegebiet" onclick={(e) => zuAbschnitt(e, 'servicegebiet')}>
        Servicegebiet
      </a>
      <a class="link" href="/#safes" onclick={(e) => zuAbschnitt(e, 'safes')}>Die Safes</a>
      <a class="link" href="/#preise" onclick={(e) => zuAbschnitt(e, 'preise')}>Preise</a>
      <!-- Bewusst ohne Router: der Ratgeber ist statisch vorgerendert (eigene Seiten). -->
      <a class="link" href="/ratgeber/">Ratgeber</a>
      <a class="link" href="/hilfe/">Anleitungen</a>
      <a class="link" href="/fernwartung" onclick={(e) => navigiere(e, '/fernwartung')}>Fernwartung</a>
    </nav>

    <div class="kopf-aktionen">
      <a class="tb-btn-sekundaer" href="https://portal.it-karsten-fischer.de">Anmelden</a>
      <a class="tb-btn-primary" href="/#registrieren" onclick={(e) => zuAbschnitt(e, 'registrieren')}>
        Jetzt Registrieren
      </a>
      <button
        type="button"
        class="menu-knopf"
        aria-expanded={offen}
        aria-label="Menü"
        onclick={() => (offen = !offen)}
      >
        ☰
      </button>
    </div>
  </div>

  {#if offen}
    <nav class="mobil-nav" aria-label="Hauptnavigation (mobil)">
      <a href="/#leistungen" onclick={(e) => zuAbschnitt(e, 'leistungen')}>Technik-Support</a>
      <a href="/#servicegebiet" onclick={(e) => zuAbschnitt(e, 'servicegebiet')}>Servicegebiet</a>
      <a href="/#safes" onclick={(e) => zuAbschnitt(e, 'safes')}>Die Safes</a>
      <a href="/#preise" onclick={(e) => zuAbschnitt(e, 'preise')}>Preise</a>
      <a href="/ratgeber/">Ratgeber</a>
      <a href="/hilfe/">Anleitungen</a>
      <a href="/fernwartung" onclick={(e) => navigiere(e, '/fernwartung')}>Fernwartung</a>
      <a href="https://portal.it-karsten-fischer.de">Anmelden</a>
    </nav>
  {/if}
</header>

<style>
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  .mobil-nav {
    display: none;
  }

  @media (max-width: 55rem) {
    .mobil-nav {
      display: flex;
      flex-direction: column;
      padding: 0.5rem 1.5rem 1.25rem;
      gap: 0.25rem;
      border-top: 1px solid #e7edf3;
    }

    .mobil-nav a {
      padding: 0.75rem 0;
      font-weight: 600;
      color: var(--tb-navy-900);
      text-decoration: none;
      border-bottom: 1px solid #eef2f6;
    }
  }
</style>
